import { cn } from '@/lib/utils'
import { Separator } from '@/components/ui/separator'
import type { NavigationItem } from '../../types/workspace'
import { SidebarNavItem } from './SidebarNavItem'

interface SidebarSectionProps {
  label?: string
  items: NavigationItem[]
  isExpanded: boolean
  showSeparator?: boolean
}

export function SidebarSection({
  label,
  items,
  isExpanded,
  showSeparator = true,
}: SidebarSectionProps) {
  if (items.length === 0) return null

  return (
    <div>
      {showSeparator && (
        <div className={cn(
          'my-2 transition-all duration-200',
          isExpanded ? 'mx-0' : 'mx-2'
        )}>
          <Separator className="opacity-50" />
        </div>
      )}

      {label && (
        <div
          className={cn(
            'transition-all duration-200 overflow-hidden',
            isExpanded ? 'h-auto opacity-100' : 'h-6 opacity-0'
          )}
        >
          <p className="px-3 py-1.5 text-[10px] font-medium text-muted-foreground/70 uppercase tracking-wider">
            {label}
          </p>
        </div>
      )}

      <div className="space-y-0.5">
        {items.map((item) => (
          <SidebarNavItem key={item.href} item={item} isExpanded={isExpanded} />
        ))}
      </div>
    </div>
  )
}
